import type { FC } from "react";

import { cn } from "@/lib/utils";
import type { DiabeticPatient, Disease, Pathology } from "@/types/api/patient";
import {
  diabeticOptions,
  diseaseOptions,
  getDiseasesLabel,
  pathologiesOptions,
} from "@/utils/patient";

type DiseaseLabelProps = {
  disease?: Disease | DiabeticPatient | Pathology;
  customLabel?: string;
  className?: string;
};

const getLabelColors = (disease?: Disease | DiabeticPatient | Pathology) => {
  if (diseaseOptions.find((elem) => elem.value === disease)) {
    return ["bg-disease-50", "border-disease-200", "text-disease-500"];
  }
  if (pathologiesOptions.find((elem) => elem.value === disease)) {
    return ["bg-pathology-50", "border-pathology-200", "text-pathology-500"];
  }
  if (diabeticOptions.find((elem) => elem.value === disease)) {
    return ["bg-diabet-50", "border-diabet-200", "text-diabet-500"];
  }
  return ["bg-disease-50", "border-disease-200", "text-disease-500"];
};

const DiseaseLabel: FC<DiseaseLabelProps> = ({
  disease,
  customLabel,
  className,
}) => {
  const colors = getLabelColors(disease);
  return (
    <div
      className={cn([
        "border rounded-2xl py-[2px] px-2",
        colors[0],
        colors[1],
        colors[2],
        className,
      ])}
    >
      {disease ? getDiseasesLabel(disease) : customLabel}
    </div>
  );
};

export default DiseaseLabel;
